import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=837c94e2&"
import script from "./Ordenes.vue?vue&type=script&lang=js&"
export * from "./Ordenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports